import React, { useContext } from 'react';
import { Button } from '@fluentui/react-components';
import { I18nContext, I18nModel } from '@bingads-webui/copilot-i18n';
import { ChatOffRegular } from '@fluentui/react-icons';
import { LiveAgentConnectionState } from '../helpers';

interface LiveAgentEndChatProps {
  liveAgentState: LiveAgentConnectionState;
  onEndChatClick?: () => void;
}

export const LiveAgentEndChat: React.FC<LiveAgentEndChatProps> = ({ liveAgentState, onEndChatClick }) => {
  const i18n = useContext(I18nContext) as I18nModel;

  if (liveAgentState !== LiveAgentConnectionState.DISCONNECTED) {
    const bottomButtonText = liveAgentState === LiveAgentConnectionState.IN_PROGRESS ? _TL_('Stop connecting') : _TL_('End chat');

    return (
      <div className="live-agent-bottom-end-chat" style={{ display: 'flex', marginBottom: 16, justifyContent: 'center' }}>
        <Button icon={<ChatOffRegular />} appearance="transparent" size="small" onClick={onEndChatClick}>
          {i18n.getString(bottomButtonText)}
        </Button>
      </div>
    );
  }
  return null;
};
